import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export default function FinalCTA() {
  return (
    <section className="relative mx-auto max-w-7xl px-6 pb-20 pt-8" data-testid="final-cta-section">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.03] px-8 py-20 text-center backdrop-blur-md md:px-14 md:py-28"
      >
        <div
          className="absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00FF66]/12 blur-[130px]"
          aria-hidden="true"
        />
        <div className="relative z-10">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="font-display text-5xl font-black leading-[0.95] tracking-tighter md:text-7xl xl:text-8xl"
          >
            Start <span className="text-[#00FF66]">shipping.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
            className="mx-auto mt-6 max-w-md text-base leading-relaxed text-white/55 md:text-lg"
          >
            One signal for your whole team. Set up in minutes — free for the first
            seven days, no credit card required.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.3, ease: EASE }}
            className="mt-10 flex flex-wrap items-center justify-center gap-4"
          >
            <motion.a
              href="/signup"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.96 }}
              className="flex items-center gap-3 rounded-full bg-[#00FF66] px-9 py-4 text-sm font-bold text-black shadow-[0_0_44px_rgba(0,255,102,0.4)]"
              data-testid="final-cta-start-trial-button"
            >
              Start free trial
              <ArrowRight className="h-4 w-4" />
            </motion.a>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}
